import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import logo from '../../assets/images/logo.svg';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="row">
          {/* Logo & Description */}
          <div className="col-md-3">
            <div className="footer_logo">
              <Link to="/">
                <img
                  src={logo}
                  className="img-fluid"
                  alt="Logo"
                  style={{ width: '150px', height: 'auto', cursor: 'pointer' }}
                />
              </Link>
              <p>{t('footer_description')}</p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-md-3">
            <div className="footer-menu">
              <div className="main-title">
                <h5>{t('quick_links')}</h5>
              </div>
              <ul>
                <li>
                  <Link
                    to="/about-us"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    {t('about_us')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    {t('services')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/blog"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    {t('blogs')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/appointment"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    {t('book_consultation')}
                  </Link>
                </li>

                <li>
                  <Link
                    to="/terms-conditions"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    {t('terms')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacy-policy"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    {t('privacy')}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Resources */}
          <div className="col-md-3">
            <div className="footer-menu">
              <div className="main-title">
                <h5>{t('resources')}</h5>
              </div>
              <ul>
                <li>{t('resource_uae_setup')}</li>
                <li>{t('resource_global_legal')}</li>
                <li>{t('resource_real_estate')}</li>
              </ul>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-md-3">
            <div className="footer-menu">
              <div className="Contated-title">
                <h5>{t('contact_us')}</h5>
              </div>

              {/* Address */}
              <div className="Contact_details d-flex g-20">
                <div
                  className="icon d-flex align-items-center justify-content-center"
                  style={{
                    backgroundColor: '#082341',
                    color: '#ffffff',
                    borderRadius: '50%',
                    width: '25px',
                    height: '25px',
                    fontSize: '12px',
                    flexShrink: 0,
                  }}
                >
                  <a
                    href="https://maps.app.goo.gl/dpdpCi9gf8hyVyqcA"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none text-dark"
                  >
                    {' '}
                    <i className="bi bi-geo-alt-fill text-white"></i>
                  </a>
                </div>
                <div className="description ps-2">
                  <a
                    href="https://maps.app.goo.gl/dpdpCi9gf8hyVyqcA"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none text-dark"
                  >
                    {' '}
                    <p style={{ marginBottom: 0 }}>{t('footer_address')}</p>
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="Contact_details d-flex g-20 mt-2">
                <div
                  className="icon d-flex align-items-center justify-content-center"
                  style={{
                    backgroundColor: '#082341',
                    color: '#ffffff',
                    borderRadius: '50%',
                    width: '25px',
                    height: '25px',
                    fontSize: '12px',
                    flexShrink: 0,
                  }}
                >
                  <a
                    href="mailto:info@Shahlpo.ae"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                  >
                    {' '}
                    <i className="bi bi-envelope-fill"></i>
                  </a>
                </div>
                <div className="description ps-2">
                  <a
                    href="mailto:info@Shahlpo.ae"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                  >
                    <p style={{ marginBottom: 0 }}>info@Shahlpo.ae</p>
                  </a>
                </div>
              </div>

              {/* Phone */}
              <div className="Contact_details d-flex g-20 mt-2">
                <div
                  className="icon d-flex align-items-center justify-content-center"
                  style={{
                    backgroundColor: '#082341',
                    color: '#ffffff',
                    borderRadius: '50%',
                    width: '25px',
                    height: '25px',
                    fontSize: '12px',
                    flexShrink: 0,
                  }}
                >
                  <a
                    href="tel:+971585703027"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                  >
                    <i className="bi bi-telephone-fill"></i>
                  </a>
                </div>
                <div className="description ps-2">
                  <a
                    href="tel:+971585703027"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                  >
                    <p style={{ marginBottom: 0 }}>+971-585703027</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="row mt-70">
          <div className="col-md-12 text-center">
            <div className="copyright_sec">
              <div
                className="footer d-flex justify-content-between align-items-center"
                style={{ fontSize: '14px' }}
              >
                <div className="footer-left">
                  <p className="mb-0">
                    © {currentYear} {t('copyright')}
                  </p>
                </div>
                <div className="footer-right">
                  <p className="mb-0">
                    {t('designed_by')}{' '}
                    <a
                      href="https://anaxistech.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none', color: '#db2217' }}
                    >
                      Anaxistech
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
